import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateTemplateRequest,
} from '../templates.actions'
import { getCreateTemplateState } from '../templates.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import jsonToFormData from 'json-form-data'
import { getTemplateTypesState } from '@shared/shared.select'
import { FetchTemplateTypesRequest } from '@shared/shared.actions'

@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.css'],
})
export class CreateTemplateComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public templateTypes$: Subscription
  public templateTypes = []
  public templateTypesTranslateKeys = []
  public templateTypesTranslateDefaults = {}

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createTemplate'))
    this.state$ = this.store
      .pipe(select(getCreateTemplateState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.templateTypes$ = this.store
      .pipe(select(getTemplateTypesState))
      .subscribe((state) => {
        this.templateTypes = state.toJS()
        this.templateTypesTranslateKeys = this.templateTypes.map(
          (template) => template.translationKey,
        )
        this.templateTypesTranslateDefaults = this.templateTypes.reduce(
          (prev, current) => {
            return { ...prev, [current.translationKey]: current.title }
          },
          {},
        )
      })

    this.store.dispatch<any>(new FetchTemplateTypesRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    if (e?.target?.name === 'file') {
      this.store.dispatch(
        new UpdateField(
          e.target.name,
          e.target.files[0],
          'createTemplate.data',
        ),
      )
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'createTemplate.data',
        ),
      )
    }

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createTemplate',
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules: any = {
      name: 'required',
    }

    if (this.templateTypes.length) {
      rules.type = 'required'
    }

    const validator = new Validator(
      {
        name: data.get('name'),
        type: data.get('type'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new CreateTemplateRequest(
          jsonToFormData({ ...payload, type: payload.type?.name }),
        ),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createTemplate',
        ),
      )
    }
  }
}
